module.exports = __webpack_public_path__ + "static/media/bottlings16.69f83c7a.jpg";